'use client';

import { I18nProvider } from '@freedraw/i18n/react';
import type { AppLocale } from '@freedraw/i18n/shared';
import dynamic from 'next/dynamic';

import type { LegalPageProps } from '@/components/legal/legal-page';
import { MuiAppProvider } from '@/components/mui-app-provider';

// Same pattern as LandingEntry: providers stay outside the client-only boundary.
const LegalPage = dynamic(async () => (await import('@/components/legal/legal-page')).LegalPage, {
  ssr: false,
  loading: () => <div className="board-loading-shell" aria-hidden="true" />
});

type LegalEntryProps = LegalPageProps & {
  initialLocale: AppLocale;
};

export function LegalEntry({ initialLocale, ...props }: LegalEntryProps) {
  return (
    <I18nProvider initialLocale={initialLocale}>
      <MuiAppProvider initialPreference="light">
        <LegalPage {...props} />
      </MuiAppProvider>
    </I18nProvider>
  );
}
